import { createFileRoute, redirect } from '@tanstack/react-router'
import { lazy, Suspense } from 'react'
import Loader from '@/components/common/Loader'

const DocumentComparisonPage = lazy(async () => {
  const module = await import('@/features/city-clerk/document-comparison')
  return { default: module.DocumentComparisonPage }
})

export type DocumentComparisonSearch = {
  type?: 'site-plan' | 'alta-survey' | 'ti-submittal'
  left?: string
  right?: string
  compared?: boolean
}

export const Route = createFileRoute(
  '/(app)/city-clerk/$id/projects/$projectId/permit-checklist-setup/$permitId/$permitSubmitalId/document-comparison/',
)({
  beforeLoad: ({ context }) => {
    if (context.auth.loading) return
    if (!context.auth.userInfo?.uiCapabilities?.firstSubmittalView) {
      throw redirect({ to: '/access-denied' })
    }
  },
  validateSearch: (
    search: Record<string, unknown>,
  ): DocumentComparisonSearch => {
    return {
      type:
        search.type === 'site-plan' ||
        search.type === 'alta-survey' ||
        search.type === 'ti-submittal'
          ? search.type
          : undefined,
      left: typeof search.left === 'string' ? search.left : undefined,
      right: typeof search.right === 'string' ? search.right : undefined,
      compared:
        search.compared === true || search.compared === 'true'
          ? true
          : undefined,
    }
  },
  component: DocumentComparisonRouteComponent,
  pendingComponent: () => {
    return (
      <div className="h-page bg-(--color-surface) flex items-center justify-center z-9999">
        <Loader size="lg" />
      </div>
    )
  },
})

function DocumentComparisonRouteComponent() {
  const params = Route.useParams()
  const search = Route.useSearch()
  const navigate = Route.useNavigate()
  return (
    <Suspense
      fallback={
        <div className="h-page bg-(--color-surface) flex items-center justify-center z-9999">
          <Loader size="lg" />
        </div>
      }
    >
      <DocumentComparisonPage
        cityId={params.id}
        projectId={params.projectId}
        permitId={params.permitId}
        permitSubmitalId={params.permitSubmitalId}
        search={search}
        onSearchChange={(next) =>
          navigate({ search: (prev) => ({ ...prev, ...next }) })
        }
      />
    </Suspense>
  )
}
